/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, cap: NonNullable<unknown> }} Tournament_Cap_Waitlist_PlayerInputs */



/**
* | output |
* | --- |
* | "This event is full ({count}/{cap}). You can still sign up: you'll be on the waitlist until an organizer gives you a seat." |
*
* @param {Tournament_Cap_Waitlist_PlayerInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_cap_waitlist_player = /** @type {((inputs: Tournament_Cap_Waitlist_PlayerInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Cap_Waitlist_PlayerInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Ce tournoi est complet (${i?.count}/${i?.cap}). Vous pouvez encore vous inscrire : vous serez en liste d'attente jusqu'à ce qu'un organisateur vous accepte.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Este torneo está completo (${i?.count}/${i?.cap}). Aún puede inscribirse: estará en lista de espera hasta que un organizador le admita.`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Este torneio está lotado (${i?.count}/${i?.cap}). Você ainda pode se inscrever: ficará na lista de espera até um organizador admitir você.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Questo torneo è completo (${i?.count}/${i?.cap}). Puoi ancora iscriverti: sarai in lista d'attesa finché un organizzatore non ti ammette.`)
	return /** @type {LocalizedString} */ (`This event is full (${i?.count}/${i?.cap}). You can still sign up: you'll be on the waitlist until an organizer gives you a seat.`)
});